import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import * as ProductTileProductMapper from "../../mappers/productTileProduct.mapper";
import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: ProductImpressionTrackingInfo) => {
    const event: AnalyticsEvent<ProductImpressionTrackingInfo> = {
        event: EventType.ProductImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackProductTile = (
    product: Product<ProductFieldSet.ProductTile>,
    list?: string,
    placement?: number
) => {
    const trackingInfo: ProductImpressionTrackingInfo = {
        ...ProductTileProductMapper.toProductImpression(product),
        list: list,
        placement: placement
    };

    track(trackingInfo);
};
